import { useCallback } from "react";
import { DesktopState } from "./desktopState";

export function Controls({ desktopState, setDesktopState, onReset }: { desktopState: DesktopState; setDesktopState: (value: React.SetStateAction<DesktopState>) => void; onReset: () => void; }) {
  const activateScissors = useCallback(() => {
    setDesktopState(desktopState => ({ ...desktopState, tool: "SCISSORS" }));
  }, [desktopState, setDesktopState]);
  const activateHand = useCallback(() => {
    setDesktopState(desktopState => ({ ...desktopState, tool: "HAND" }));
  }, [desktopState, setDesktopState]);
  const activateBin = useCallback(() => {
    setDesktopState(desktopState => ({ ...desktopState, tool: "BIN" }));
  }, [desktopState, setDesktopState]);
  const confirmReset = useCallback(() => {
    if (confirm("Are you sure you want to reset the workspace?")) {
      onReset();
    }
  }, [desktopState, setDesktopState]);
  const loadHelp = useCallback(() => {
    setDesktopState(desktopState => ({
      ...desktopState,
      pinboard: {
        ...desktopState.pinboard,
        papers: [
          ...desktopState.pinboard.papers,
          {
            id: Math.random().toString(),
            type: "text",
            pos: [200 + Math.round(Math.random() * 100), 200 + Math.round(Math.random() * 100)],
            lines: desktopState.help.split("\n")
          }
        ]
      }
    }));
  }, [desktopState, setDesktopState]);
  const toggleSilence = useCallback(() => {
    setDesktopState(desktopState => ({
      ...desktopState,
      volume: desktopState.volume === "SILENT" ? "NOISY" : "SILENT"
    }));
  }, [desktopState, setDesktopState]);

  return (
    <section className="flex justify-end absolute right-0 top-0 m-4">
      <button
        className={`p-2 m-2 text-xs rounded ${desktopState.tool === "HAND" ? "bg-blue-500 text-white" : "bg-white text-black"}`}
        onClick={activateHand}
      >
        Hand ⎇V
      </button>
      <button
        className={`p-2 m-2 text-xs rounded ${desktopState.tool === "SCISSORS" ? "bg-blue-500 text-white" : "bg-white text-black"}`}
        onClick={activateScissors}
      >
        Scissors ⎇C
      </button>
      <button
        className={`p-2 m-2 text-xs rounded ${desktopState.tool === "BIN" ? "bg-blue-500 text-white" : "bg-white text-black"}`}
        onClick={activateBin}
      >
        Trash ⎇D
      </button>
      <button
        className={`p-2 m-2 text-xs rounded bg-white text-black`}
        onClick={confirmReset}
      >
        Reset
      </button>
      <button
        className={`p-2 m-2 text-xs rounded bg-white text-black`}
        onClick={loadHelp}
      >
        Help
      </button>
      <button
        className={`p-2 m-2 text-xs rounded bg-white text-black`}
        onClick={toggleSilence}
      >
        {desktopState.volume === "SILENT" ? "🔇" : "🔊"}
      </button>
    </section>
  );
}
